import { TSearchParams } from 'legacy/lut/classes/services/api/SearchApi'

import { IPartnerSearchQueryParams } from 'clickNgo/models/search'

export const mapQueryParamsToRequestData = (params: IPartnerSearchQueryParams): TSearchParams => {
  return {
    query: params.search,
    AgreementNo: params.partner.agreementNumber,
    PartnerID: params.partner.partnerId,
    CommunicationName: params.partner.communicationName,
    CompanyLegalName: params.partner.companyLegalName,
    TaxID: params.partner.taxId,
    Country: params.partner.isLegal ? params.partner.legalCountry : params.partner.country,
    City: params.partner.isLegal ? params.partner.legalCity : params.partner.city,
    State: params.partner.isLegal ? params.partner.legalState : params.partner.state,
    ZIPCode: params.partner.isLegal ? params.partner.legalZipCode : params.partner.zipCode,
    LocationID: params.partner.locationId,
    STORE_NUM: params.partner.storeNumber,
    URL: params.partner.url,
    Address: params.partner.isLegal ? params.partner.legalAddress : params.partner.address,
    ContactID: params.contact.contactId,
    LearnerID: params.contact.learnerId,
    FirstName: params.contact.firstName,
    LastName: params.contact.lastName,
    Email: params.contact.email,
    IsBusinessPartner: params.common.isBusinessPartner ? '1' : '',
    HierarchyType: params.common.isBranchVisible ? '' : 'Headquarters',
    ISR: params.common.isMine ? '1' : '',
    IsPFPartner: '',
    IsAmpRet: params.common.isRetailAmplify ? '1' : '',
    IsAmpComm: params.common.isCommercialAmplify ? '1' : '',
    IsRet: params.common.isRetail ? '1' : '',
    IsComm: params.common.isCommercial ? '1' : '',
    IsLegal: params.partner.isLegal ? '1' : '',
    GeoMarket: params.common.market,
    IsDis: params.common.isDistributors ? '1' : '',
  }
}
